export const hero = {
  name: "SCADA-HMI-02",
  badge: "Critical Risk",
  type: "Human-Machine Interface",
  model: "Rockwell Automation PanelView Plus 7",
};

export const stats = [
  {
    key: "risk",
    label: "Risk Score",
    value: 89,
    change: -15,
    icon: "risk",
  },
  {
    key: "compliance",
    label: "Compliance",
    value: 56.8,
    suffix: "% verified",
    change: 5,
    icon: "shield",
  },
  {
    key: "anomaly",
    label: "Anomaly Score",
    value: 92,
    change: 23,
    icon: "alert",
  },
  {
    key: "mttr",
    label: "Mean Time to Resolve",
    value: 6.8,
    suffix: "hrs",
    change: null,
    icon: "clock",
  },
];

export const technicalSpecs = [
  { label: "IP Address", value: "192.168.1.52" },
  { label: "MAC Address", value: "00:1A:2B:3C:4D:6F" },
  { label: "Firmware", value: "v3.8.2", tone: "danger", hint: "Outdated" },
  { label: "Physical Zone", value: "Zone B - Control Room" },
  { label: "Network Segment", value: "OT-CTRL-SEGMENT-B" },
  { label: "Serial Number", value: "SN-2023-HMI-00892" },
  { label: "Uptime", value: "89 days" },
  { label: "Last Patch", value: "2023-06-15" },
];

export const activeProtocols = ["EtherNet/IP", "CIP", "HTTP", "Modbus TCP"];
export const openPorts = ["44318", "80", "443", "502"];

export const riskAssessment = {
  title: "Risk Assessment",
  items: [
    "SCADA-HMI-02 exhibits elevated risk indicators.",
    "Anomalous traffic spike at 12:00 with Modbus requests exceeding baseline by 350%.",
    "Outdated firmware (v3.8.2) exposes the asset to CVE-2023-4501 (CVSS 9.8), a critical RCE vulnerability with known active exploits.",
  ],
};

export const threatIndicators = [
  "Unauthorized write attempts from unknown source (10.0.0.55)",
  "Critical RCE vulnerability with active exploit in the wild",
  "Firmware 6+ months behind security baseline",
  "Weak authentication on Modbus protocol",
];

export const aiRecommendations = [
  "Immediately isolate from external network segments",
  "Apply firmware update v4.3.0 during maintenance window",
  "Block traffic from suspicious IP 10.0.0.55",
  "Enable Modbus authentication enforcement",
  "Schedule penetration test within 48 hours",
];

export const protocolTrafficSeries = [
  {
    name: "Modbus",
    data: [120, 140, 180, 220, 450, 260, 200, 190, 160, 140, 120, 110],
  },
  {
    name: "MQTT",
    data: [60, 70, 65, 80, 90, 75, 72, 70, 68, 65, 60, 58],
  },
  {
    name: "OPC-UA",
    data: [40, 45, 50, 48, 70, 60, 58, 55, 50, 48, 45, 42],
  },
  {
    name: "Anomaly",
    data: [20, 25, 30, 35, 120, 50, 40, 38, 36, 30, 28, 25],
  },
];

export const protocolTrafficCategories = [
  "02:00",
  "04:00",
  "06:00",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
  "20:00",
  "22:00",
  "24:00",
];

export const vulnerabilities = [
  {
    cve: "CVE-2023-4501",
    title: "Remote Code Execution",
    severity: "Critical",
    cvss: 9.8,
    exploit: "Active",
    status: "Unpatched",
    remediation: "Update to firmware v4.3.0",
  },
  {
    cve: "CVE-2023-3892",
    title: "Authentication Bypass",
    severity: "Critical",
    cvss: 9.1,
    exploit: "Active",
    status: "Investigation",
    remediation: "Apply vendor patch",
  },
  {
    cve: "OT-2024-001",
    title: "Unauthorized Write Control",
    severity: "High",
    cvss: 8.2,
    exploit: "None",
    status: "Investigation",
    remediation: "Review access control policies",
  },
  {
    cve: "OT-2024-002",
    title: "Weak Authentication Protocol",
    severity: "Medium",
    cvss: 6.5,
    exploit: "None",
    status: "Mitigated",
    remediation: "Enable strong auth",
  },
];

export const commandHistory = [
  { time: "14:32:15", command: "READ_HOLDING_REGISTERS", source: "192.168.1.100", proto: "Modbus", status: "Normal" },
  { time: "14:31:58", command: "WRITE_SINGLE_COIL", source: "192.168.1.45", proto: "Modbus", status: "Warning" },
  { time: "14:31:28", command: "SUBSCRIBE", source: "192.168.1.78", proto: "Modbus", status: "Normal" },
  { time: "14:31:05", command: "READ_COILS", source: "192.168.1.100", proto: "Modbus", status: "Normal" },
  { time: "14:30:52", command: "WRITE_MULTIPLE_REGISTERS", source: "10.0.0.55", proto: "Modbus", status: "Critical" },
  { time: "14:30:15", command: "PUBLISH", source: "192.168.1.52", proto: "MQTT", status: "Normal" },
  { time: "14:30:02", command: "FORCE_SINGLE_COIL", source: "Unknown", proto: "Modbus", status: "Critical" },
  { time: "14:29:58", command: "READ_INPUT_REGISTERS", source: "192.168.1.100", proto: "Modbus", status: "Normal" },
];

export const accessEvents = [
  { name: "OT-OPERATOR-01", detail: "Card Auth", time: "14:30:05" },
  { name: "SCADA-SVC", detail: "API Key", time: "14:28:15" },
  { name: "Unknown", detail: "Invalid Cert", time: "14:18:45" },
  { name: "MAINTENANCE-02", detail: "Firmware check", time: "14:12:18" },
  { name: "10.0.0.55", detail: "Write registers", time: "14:18:45" },
];

export const riskTrend = [60, 65, 68, 70, 75, 78, 82, 86];
export const riskTrendCategories = ["Jan 1", "Jan 3", "Jan 5", "Jan 8", "Jan 10", "Jan 12", "Jan 14", "Jan 15"];

export const complianceStatus = [
  { label: "Access Control", value: 65, color: "#f97316" },
  { label: "Patch Management", value: 35, color: "#ef4444" },
  { label: "Logging & Monitoring", value: 55, color: "#f59e0b" },
  { label: "Incident Response", value: 85, color: "#22c55e" },
];

export const networkConnections = [
  { src: "192.168.1.100", dest: "192.168.1.45", proto: "Modbus TCP", port: "502", packets: "15,234", status: "Normal" },
  { src: "192.168.1.78", dest: "192.168.1.45", proto: "OPC-UA", port: "4840", packets: "8,921", status: "Normal" },
  { src: "10.0.0.55", dest: "192.168.1.45", proto: "Modbus TCP", port: "502", packets: "342", status: "Suspicious" },
  { src: "192.168.1.52", dest: "192.168.1.45", proto: "MQTT", port: "1883", packets: "5,621", status: "Normal" },
  { src: "Unknown", dest: "192.168.1.45", proto: "Modbus TCP", port: "502", packets: "28", status: "Malicious" },
];
